// Module
var code = "<div> <div class=\"icon-container\"> <span> <img class=\"icon-img\" ng-if=\"$ctrl.iconSrc\" ng-src=\"{{ $ctrl.iconSrc }}\"/> </span> </div> <div class=\"label-value-container\"> <div>{{ $ctrl.label }}</div> <div class=\"selected-value text-capitalize\">{{ $ctrl.value }}</div> </div> </div> ";
// Exports
export default code;